import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { IsSameCoordPipe } from "./is-same-coord.pipe";
import { ExtractCostPipe } from "./extract-cost.pipe";
import { ExtractTravellerDetailCostPipe } from "./extract-traveller-detail-cost.pipe";
import { IsEditableCellPipe } from "./is-editable-cell.pipe";
import { IsRowTypePipe } from "./is-row-type.pipe";
import { QuotationPriceToolsService } from "./quotation-price-tools.service";

@NgModule({
 imports: [CommonModule],
 exports: [
     IsSameCoordPipe,
     ExtractCostPipe,
     ExtractTravellerDetailCostPipe,
     IsEditableCellPipe,
     IsRowTypePipe,
 ],
 declarations: [
     IsSameCoordPipe,
     ExtractCostPipe,
     ExtractTravellerDetailCostPipe,
     IsEditableCellPipe,
     IsRowTypePipe,
 ],
 providers: [
     QuotationPriceToolsService,
 ],
})
export class QuotationPricePipesModule { }
